export * from './pesquisa.base.controller';
export * from './base.controller';
export * from './detalhe.base.controller';



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/helpers/index.ts